const state = {
  allowed: [
    'PT',
    'GB',
    'ES',
    'CZ'
  ],
  default: 'PT',
}

const getters = {
  allowed: state => state.allowed,
}

export default {
  state,
  getters,
}
